import React, { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

// A modal pop-up in place of window.confirm(), used as a promise:
//
//   const [confirm, confirmDialog] = useConfirmDialog();
//   if (!(await confirm({ title: 'Delete this?', message: '...', danger: true, confirmLabel: 'Delete' }))) return;
//   ...
//   return (<> ...page... {confirmDialog} </>);
//
// Options: title, message, items (bullet list), confirmLabel, cancelLabel, danger, icon.
export const useConfirmDialog = () => {
    const [options, setOptions] = useState(null);
    const resolver = useRef(null);

    const confirm = useCallback((next) => new Promise((resolve) => {
        resolver.current = resolve;
        setOptions(next || {});
    }), []);

    const finish = (answer) => {
        if (resolver.current) resolver.current(answer);
        resolver.current = null;
        setOptions(null);
    };

    const dialog = (
        <ConfirmDialog
            open={Boolean(options)}
            {...(options || {})}
            onConfirm={() => finish(true)}
            onCancel={() => finish(false)}
        />
    );

    return [confirm, dialog];
};

export default useConfirmDialog;
